import React from 'react';
import PropTypes from 'prop-types';
import {Box, IconButton} from '@mui/material';
import {
    KeyboardArrowLeft,
    KeyboardArrowRight,
} from '@mui/icons-material';
import {ezprOrange} from './_helpers';

/**
 * @param {PaginationActionsWithoutFirstAndLastPage.propTypes} props
 * @return {JSX.Element}
 * @constructor
 */
export function PaginationActionsWithoutFirstAndLastPage(props) {
    const {count, page, rowsPerPage, onPageChange} = props;

    const atFirst = page === 0;
    const atLast = page >= Math.ceil(count / rowsPerPage) - 1;

    const from = page * rowsPerPage + 1;
    const to = Math.min(count, (page + 1) * rowsPerPage);

    const iconSx = (disabled) => ({
        color: disabled ? '#CCC' : '#666',
        fontSize: '20px',
    });

    return (
        <Box sx={{display: 'flex', alignItems: 'center', whiteSpace: 'nowrap'}}>
            <IconButton onClick={(e) => onPageChange(e, page - 1)} disabled={atFirst}>
                <KeyboardArrowLeft sx={iconSx(atFirst)} />
            </IconButton>

            <Box
                component="span"
                sx={{
                    mx: 1.5,
                    fontSize: 14,
                    fontWeight: 500,
                    color: '#333',
                    display: 'inline-flex',
                    alignItems: 'center',
                }}
            >
                <Box component="span" sx={{color: ezprOrange}}>{from}</Box>
                <Box component="span" sx={{mx: 0.5, color: ezprOrange}}>–</Box>
                <Box component="span" sx={{color: ezprOrange}}>{to}</Box>
                {'\u00A0of\u00A0'}
                <Box component="span">{count}</Box>
            </Box>

            <IconButton onClick={(e) => onPageChange(e, page + 1)} disabled={atLast}>
                <KeyboardArrowRight sx={iconSx(atLast)} />
            </IconButton>
        </Box>
    );
}

PaginationActionsWithoutFirstAndLastPage.propTypes = {
    count: PropTypes.number.isRequired,
    page: PropTypes.number.isRequired,
    rowsPerPage: PropTypes.number.isRequired,
    onPageChange: PropTypes.func.isRequired,
};
